import { render, staticRenderFns } from "./Docwriter.vue?vue&type=template&id=13d5e181&scoped=true&"
import script from "./Docwriter.vue?vue&type=script&lang=js&"
export * from "./Docwriter.vue?vue&type=script&lang=js&"
import style0 from "./Docwriter.vue?vue&type=style&index=0&id=13d5e181&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d5e181",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QImg,QCardActions});
